// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2G6JC","icon":"Footer_icon__3RE99"};